var map = {
	"./C.svg": 1334,
	"./D.svg": 1335,
	"./E.svg": 1336,
	"./F.png": 1337,
	"./F.svg": 1338,
	"./G.svg": 1339,
	"./H.svg": 1340,
	"./I.svg": 1341,
	"./J.svg": 1342,
	"./K.svg": 1343,
	"./L.svg": 1344,
	"./arrow-curved-dashed-line.svg": 1345,
	"./arrow-curved-line.svg": 1346,
	"./arrow-dotted-line.svg": 1347,
	"./arrow-straight-line.svg": 1348,
	"./background.png": 1349,
	"./ball_1.png": 210,
	"./ball_2.png": 211,
	"./ball_3.webp": 1350,
	"./basketBall_p1.jpg": 1351,
	"./basketBall_p2.jpg": 1352,
	"./colors.png": 1353,
	"./cone_blue.png": 1354,
	"./cone_grey.png": 1355,
	"./cone_red.png": 1356,
	"./cone_yellow.png": 1357,
	"./connect.png": 1358,
	"./coordination_ladder_1.png": 213,
	"./coordination_ladder_2.png": 214,
	"./cross.png": 217,
	"./css_sprites.png": 1359,
	"./curve-line.png": 1360,
	"./done.png": 1361,
	"./dot.png": 218,
	"./downDropIcon.png": 1362,
	"./downloadImg.png": 1363,
	"./drag.png": 134,
	"./ellipse_outlined.png": 1364,
	"./ellipse_solid.png": 206,
	"./exitFullScreenImg.png": 1365,
	"./fieldWhite.svg": 1366,
	"./flag.png": 212,
	"./fullScreenImg.png": 1367,
	"./goal1.png": 1368,
	"./goal_1.png": 1369,
	"./goal_2.png": 1370,
	"./goal_3.png": 1371,
	"./highlighter.png": 220,
	"./hoop.png": 219,
	"./lightSelected.svg": 1372,
	"./line.svg": 1373,
	"./logo.png": 1374,
	"./menu.png": 1375,
	"./minus.png": 1376,
	"./obstacle.png": 1377,
	"./opponent.png": 1378,
	"./oval_outlined.png": 1379,
	"./oval_solid.png": 205,
	"./plus.png": 1380,
	"./pole_blue.png": 216,
	"./pole_red.png": 215,
	"./previouseDrawing.png": 1381,
	"./selection.png": 208,
	"./square_solid.png": 207,
	"./whiteSelected.svg": 1382
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1333;